import { Helmet } from "react-helmet-async";
import { t as translate } from "i18next";
import { TrustedLicense } from "components/V3/TrustedLicense";
import { SchoolHero } from "./SchoolHero/SchoolHero";
import { WhyPartner } from "./WhyPartner/WhyPartner";
import { SupportAreas } from "./SupportAreas/SupportAreas";
import { WhatWeOffer } from "./WhatWeOffer/WhatWeOffer";
import { SchoolMission } from "./SchoolMission/SchoolMission";
import { SchoolCTA } from "./SchoolCTA/SchoolCTA";
import { useSchoolLocal } from "./useSchoolLocal";

export const SchoolRoot = () => {
  const { t } = useSchoolLocal();

  return (
    <>
      <Helmet>
        <title>{translate("siteMap.forSchools.title")}</title>
        <meta
          name="description"
          content={translate("siteMap.forSchools.description") || ""}
        />
      </Helmet>
      <SchoolHero />
      <TrustedLicense privacyDescription={t("trusted.privacyDescription")} />
      <WhyPartner />
      <SupportAreas />
      <WhatWeOffer />
      <SchoolMission />
      <SchoolCTA />
    </>
  );
};
